import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import InboundKpiService from '_services/inbound-kpi-service';

export const fetchInboundKpi = createAsyncThunk(
  'inboundKpi/fetch',
  async (params, { signal }) => {
    return await InboundKpiService.getInboundKpi(params, signal);
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const inboundKpiSlice = createSlice({
  name: 'inboundKpi',
  initialState,
  reducers: {
    resetInboundKpi: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInboundKpi.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchInboundKpi.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchInboundKpi.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectInboundKpiData = (state) => state.inboundKpi.data;
export const selectInboundKpiStatus = (state) => state.inboundKpi.status;
export const selectInboundKpiError = (state) => state.inboundKpi.error;

export const { resetInboundKpi } = inboundKpiSlice.actions;

export default inboundKpiSlice.reducer;
